import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

import FansiMark from '@/atoms/FansiMark'
import { Media } from '@/templates/Media/Media'
import FansiKind from '@/ts/enums/global/FansiKind'
import { Survey } from '@/ts/Survey'

interface SurveysSectionProps {
  surveys: Survey[] | undefined
}

function SurveysSection({ surveys }: SurveysSectionProps) {
  const { t } = useTranslation('surveys')

  const router = useRouter()

  return surveys?.length ? (
    <>
      <section className="flex flex-col mt-8 box md:space-y-8">
        <div className="flex items-center space-x-4">
          <p className="text-2xl font-medium break-words ">
            {t('fansi_projects')}
          </p>
          <div className="">
            <FansiMark kind={FansiKind.FansiProjects} />
          </div>
        </div>
        <span className="text-black/60 !mt-4">{t('decide')}</span>
      </section>
      {surveys &&
        surveys?.map((survey) => (
          <div
            key={survey.id}
            onClick={() => router.push(`/surveys/${survey.id}`)}
            className="flex items-center justify-center"
          >
            <Media lessThan="2md">
              <img
                className="mt-8 rounded-lg cursor-pointer max-h-96"
                src={survey.banner_mobile_url}
              />
            </Media>
            <Media greaterThanOrEqual="2md">
              <img
                className="mt-8 rounded-lg cursor-pointer max-h-80"
                src={survey.banner_desktop_url}
              />
            </Media>
          </div>
        ))}
    </>
  ) : (
    <></>
  )
}

export default SurveysSection
